import React from "react";
import SolidBugIcon from "../../assets/svgs/SolidBugIcon";
import {
  DisplaySize,
  DisplayStatus,
  Alignment,
} from "../../utils/types/component-configs";
import { getHomePageUrl } from "../../utils/helpers/navigation-helper";
import { createClasses } from "../../utils/helpers/browser-helper";
import ColumnAlign from "../../atoms/column-align/ColumnAlign";
import SVGIcon from "../../atoms/svg-icon/SvgIcon";
import styles from "./ErrorPage.module.scss";
import Button from "../../atoms/button/Button";
import useTokenPageHandler from "../../hooks/useTokenPageHandler";
import { PAUSE_FLAG } from "../../utils/constants/pause";
import { BLOGS_URL } from "../../utils/constants/blog-pages";

type ErrorPageProps = {
  errorText: string;
};

export default function ErrorPage({ errorText }: ErrorPageProps) {
  const { tokenExists } = useTokenPageHandler({
    clientKey: "ERROR_PAGE",
  });

  function routeToHomePage() {
    // While paused the blogs are the only content on offer
    window.location.replace(
      PAUSE_FLAG ? BLOGS_URL : getHomePageUrl(tokenExists)
    );
  }

  return (
    <ColumnAlign
      classes={createClasses([styles.mx4, "base-page-container"])}
      verticalAlign={Alignment.CENTER}
      horizontalAlign={Alignment.CENTER}
    >
      <SVGIcon
        iconSize={DisplaySize.EXTRA_LARGE}
        iconStatus={DisplayStatus.ERROR}
      >
        {(svgProps) => <SolidBugIcon {...svgProps} />}
      </SVGIcon>
      <ColumnAlign
        classes={createClasses([
          styles.container,
          styles.hasTextCentered,
          styles.mt4,
        ])}
        horizontalAlign={Alignment.CENTER}
      >
        <p>
          We have encountered an unexpected issue. Please try again and if the
          issue persists, contact us. Mention the reason as: {errorText}
        </p>
        <Button
          buttonClick={routeToHomePage}
          buttonRole={DisplayStatus.PRIMARY}
          sizes={DisplaySize.MEDIUM}
          classes={styles.mt2}
        >
          Go to home page
        </Button>
      </ColumnAlign>
    </ColumnAlign>
  );
}
